import {
    NumberFormatAmountScale,
    NumberFormatCurrencyPlacement,
    NumberFormatCurrencySymbol,
    NumberFormatNegativeFormat,
    NumberFormatZeroDisplay,
} from "@common/types/reports/number-format-settings";

export interface SelectOption<T> {
    value: T;
    label: string;
}

export const DECIMAL_PLACES_OPTIONS: Array<SelectOption<0 | 2 | 4>> = [
    { value: 0, label: "0" },
    { value: 2, label: "2" },
    { value: 4, label: "4" },
];

export const PERCENT_DECIMAL_PLACES_OPTIONS: Array<SelectOption<number>> = [
    { value: 0, label: "0" },
    { value: 1, label: "1" },
    { value: 2, label: "2" },
    { value: 3, label: "3" },
    { value: 4, label: "4" },
];

export const NEGATIVE_FORMAT_OPTIONS: Array<
    SelectOption<NumberFormatNegativeFormat>
> = [
    { value: NumberFormatNegativeFormat.PARENTHESES, label: "(1,234)" },
    { value: NumberFormatNegativeFormat.MINUS_LEFT, label: "-1,234" },
    { value: NumberFormatNegativeFormat.MINUS_RIGHT, label: "1,234-" },
];

export const ZERO_DISPLAY_OPTIONS: Array<
    SelectOption<NumberFormatZeroDisplay>
> = [
    { value: NumberFormatZeroDisplay.DASH, label: "Dash (–)" },
    { value: NumberFormatZeroDisplay.BLANK, label: "Blank" },
    { value: NumberFormatZeroDisplay.ZERO, label: "Zero (0)" },
];

export const CURRENCY_SYMBOL_OPTIONS: Array<
    SelectOption<NumberFormatCurrencySymbol>
> = [
    { value: NumberFormatCurrencySymbol.NONE, label: "None" },
    { value: NumberFormatCurrencySymbol.DOLLAR, label: "$" },
    { value: NumberFormatCurrencySymbol.US_DOLLAR, label: "US$" },
    { value: NumberFormatCurrencySymbol.USD, label: "USD" },
];

export const CURRENCY_PLACEMENT_OPTIONS: Array<
    SelectOption<NumberFormatCurrencyPlacement>
> = [
    { value: NumberFormatCurrencyPlacement.ALL_ROWS, label: "All rows" },
    {
        value: NumberFormatCurrencyPlacement.COLUMN_HEADERS,
        label: "Column headers only",
    },
];

export const AMOUNT_SCALE_OPTIONS: Array<
    SelectOption<NumberFormatAmountScale>
> = [
    { value: NumberFormatAmountScale.FULL, label: "Full (1,234,567)" },
    { value: NumberFormatAmountScale.THOUSANDS, label: "Thousands (1,235)" },
    { value: NumberFormatAmountScale.MILLIONS, label: "Millions (1.2)" },
];

export const amountScaleDescription = (
    scale: NumberFormatAmountScale,
): string | undefined => {
    switch (scale) {
        case NumberFormatAmountScale.THOUSANDS:
            return "Amounts are in thousands";
        case NumberFormatAmountScale.MILLIONS:
            return "Amounts are in millions";
        case NumberFormatAmountScale.FULL:
            return undefined;
    }
};

export const labelFor = <T>(
    options: Array<SelectOption<T>>,
    value: T,
): string =>
    options.find((option) => option.value === value)?.label ?? String(value);
